var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReply = function SvgReply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.908 19.147C17.813 20.021 16.8 20.4 16.8 20.4s.758-.758 1.07-1.973A4.198 4.198 0 0 0 13.8 13.2h-3v3.6H9.6l-6.312-5.787L2.4 10.2l.89-.814L9.6 3.6h1.2v3.6H15a6.6 6.6 0 0 1 6.6 6.6c0 2.595-1.406 4.316-2.692 5.347m.289-1.961A5.23 5.23 0 0 0 20.4 13.8c0-2.982-2.418-5.4-5.4-5.4H9.6V5.227L4.178 10.2 9.6 15.172V12h4.2a5.4 5.4 0 0 1 5.397 5.186"
  })));
};
export default SvgReply;